export default __webpack_public_path__ + "static/media/Vikasbandhu_One.caaad0ab.jpg";